import { Button, Container, Flex, Heading, HStack, Stack, Text } from '@chakra-ui/react'

import { Mark } from '~/components/Logo'
import { PageTitle } from '~/components/PageTitle'
import { isSamlIdentityProvider, stringForSSOIdentityProvider } from '~/components/styles'
import { getAccessToken } from '~/data/accessToken'
import { SsoIdentityProvider } from '~/graphql/generated/query.types'

interface SSOLoginPageProps {
  email: string
  ssoIdentityProvider: SsoIdentityProvider
  onLogin: () => void
}

export function SSOLoginPage({ email, ssoIdentityProvider, onLogin }: SSOLoginPageProps) {
  if (getAccessToken()) {
    return null
  }

  const providerName = stringForSSOIdentityProvider(ssoIdentityProvider)
  const isSaml = isSamlIdentityProvider(ssoIdentityProvider)

  return (
    <>
      <PageTitle title="SSO" />
      <Flex height="full" width="full" align="center" justify="center">
        <Container maxW="md" py={{ base: '12', md: '24' }}>
          <Stack spacing="4">
            <Stack spacing="6" alignItems="center">
              <Mark width={20} />
              <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
                <Heading size="lg">Login with SSO</Heading>
                <HStack spacing="1" justify="center">
                  <Text color="muted">
                    {isSaml
                      ? 'Your firm is configured to use single sign-on. Log in with them below to get started.'
                      : `Your firm is configured to use ${providerName}. Log in with them below to get started.`}
                  </Text>
                </HStack>
              </Stack>
            </Stack>
            <Button width="full" variant="primary" onClick={onLogin}>
              {isSaml ? `Log in to ${email} with SSO` : `Log in to ${email} with ${providerName}`}
            </Button>
          </Stack>
        </Container>
      </Flex>
    </>
  )
}
